module.exports = __webpack_public_path__ + "static/img/bianPath.87b5ad34.gif";